<script>
import Component from '~/sites/oknanebodvere/pages/contact/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/kontakty',
      de: '/impressum',
      en: '/contact',
      sk: '/kontakty',
    },
  },
}
</script>
